const state = {
    "policyholder": {
        "name": "VORNAME",
        "lastname": "NACHNAME",
        "street": "STRAﬂE",
        "housenr": "1",
        "postcode": "12345",
        "city": "Stadt",
        "salutation": '',
        "birthdate": "yyyy-mm-dd",
        "phone": "Telefon",
        "email": "MAIL",
        "iban": "DE####################"
    },
    "properties": {
        "werbung": true,
        "beratungverz": true,
        "sepa": true,
        "agb": true,
    },
    "contract": {
        "beginn": "yyyy-mm-dd",
        "policy": "",
        "polpr": "",
        "salesagent_nr": "",
        "products": [
            {
                "product": "TYP\nText\nWeitere Angaben",
                "pictures": [
                    {
                        data: "base64",
                        filename: "Dateinamen"
                    }
                ]
            }]
    },
    "createDocument": false,
    "document": {
        data: "",
        filename: ""
    },
    "error": false,
    "messages": [
        {
            field: "FELDNAME",
            type: "E/W/I",
            message: "MELDUNGSTEXT"
        }
    ]
}

const mutations = {}

const actions = {}

const getters = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
